import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import BrandReveal from "@/components/BrandReveal";
import SiteHeader from "@/components/SiteHeader";
import SiteFooter from "@/components/SiteFooter";
import Arrival from "@/pages/Arrival";
import Brand from "@/pages/Brand";
import Orbit from "@/pages/Orbit";
import Capabilities from "@/pages/Capabilities";
import Contact from "@/pages/Contact";
import Icons from "@/pages/Icons";
import OrbitClosePreview from "@/pages/OrbitClosePreview";
import EmailSignaturePage from "@/pages/EmailSignature";
import PrivacyPolicy from "@/pages/legal/PrivacyPolicy";
import TermsOfUse from "@/pages/legal/TermsOfUse";
import CookiePolicy from "@/pages/legal/CookiePolicy";
import LegalNotice from "@/pages/legal/LegalNotice";

const REVEAL_KEY = "erenown_reveal_seen_v3";

/**
 * Scrolls to top on every in-app navigation.
 */
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function Shell() {
  const { pathname } = useLocation();
  const [showReveal, setShowReveal] = useState(false);

  // Only trigger the intro reveal on first session load AND on the Arrival route.
  useEffect(() => {
    try {
      const seen = sessionStorage.getItem(REVEAL_KEY);
      if (!seen && pathname === "/") setShowReveal(true);
    } catch {
      /* sessionStorage unavailable — skip reveal */
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const dismissReveal = () => {
    try { sessionStorage.setItem(REVEAL_KEY, "1"); } catch { /* noop */ }
    setShowReveal(false);
  };

  return (
    <>
      {showReveal && <BrandReveal onDone={dismissReveal} />}
      <SiteHeader />
      <main>
        <Routes>
          <Route path="/" element={<Arrival />} />
          <Route path="/brand" element={<Brand />} />
          <Route path="/orbit" element={<Orbit />} />
          <Route path="/capabilities" element={<Capabilities />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/icons" element={<Icons />} />
          <Route path="/orbit-close-preview" element={<OrbitClosePreview />} />
          <Route path="/signature" element={<EmailSignaturePage />} />
          <Route path="/legal/privacy" element={<PrivacyPolicy />} />
          <Route path="/legal/terms" element={<TermsOfUse />} />
          <Route path="/legal/cookie" element={<CookiePolicy />} />
          <Route path="/legal/legalnotice" element={<LegalNotice />} />
          <Route path="*" element={<Arrival />} />
        </Routes>
      </main>
      <SiteFooter />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Shell />
      </BrowserRouter>
    </div>
  );
}

export default App;
